// @ts-nocheck
import {
  Button,
  Col,
  Divider,
  Form,
  Input,
  InputRef,
  Row,
  Select,
  Space,
  Spin,
} from 'antd';
import React, { Key, useRef, useEffect, useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { del, get, post, put } from '../../../../api';
import { PlusOutlined } from '@ant-design/icons';
import delWithBody from '../../../../api/requests/delWithBody';
import { queryClient } from '../../../../config';
import { useUser } from '../../../../hooks';
import patch from '../../../../api/requests/patch';

type TagsFormProps = {
  selectedRowKeys?: Key[];
  setModalIsVisible: Dispatch<SetStateAction<boolean>>;
};

const CustomerAgentForm: React.FC<TagsFormProps> = (props) => {
  const { selectedRowKeys, setModalIsVisible } = props;
  const [form] = Form.useForm();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [tagsItems, setTagsItems] = useState([]);
  const inputRef = useRef<InputRef>(null);
  const [tagName, setTagName] = useState('');
  const [users, setUsers] = useState([]);
  const { user } = useUser();

  //ENDPOINTS
  const { isLoading: isLoadingUsers, data: usersget } = useQuery<User[]>(
    ['usuarios'],
    () => get<User[]>('/users').then((e) => e.data)
  );
  const { isLoading: isloadingScores, data: customerScores } = useQuery<any>(
      ['customerScores'],
      () => get<any>('/customerScores').then((e) => e.data)
  );
 const { isLoading: isloadingtypes, data: customertypes } = useQuery<any>(
     ['types'],
     () => get<any>('/customertypes').then((e) => e.data)
   );

 useEffect(() => {
  if (usersget) {
    const usersFiltrados = usersget.filter(user => 
      user.roles.includes("SALES") || user.roles.includes("MANAGEMENT")
    );
  
    const usersOrdenados = [...usersFiltrados];
    usersOrdenados.sort((a, b) => a.firstName.localeCompare(b.firstName));
  
    setUsers(usersOrdenados);
  }
  
   }, [usersget]);

  const handleRefresh = () => {
    queryClient.invalidateQueries(`/customers`);
  };

  const addCustomerAgentFunction = async (values: any) => {
    setIsSubmitting(true);
    let agentRequest = {
      customerIds: selectedRowKeys,
      agentId: values?.agentId,
      typeId: values?.typeId,
      customerScoreId: values?.customerScoreId,
    };

      patch('/customers/batch', agentRequest, true).then((e) => {
        if (e.statusCode === 200) {
          setModalIsVisible(false);
          handleRefresh();
        }
      });
  };

  return (
    <Spin spinning={isLoadingUsers} tip={<p>Cargando...</p>}>
      <Form
        name="add-promo"
        layout="vertical"
        form={form}
        onFinish={addCustomerAgentFunction}
      >
        <Divider />
        <Row style={{ display: 'flex', justifyContent: 'center' }}>
          <Col xs={20}>
            <Row gutter={16}>
              <Col xs={24} md={24}>
                <Form.Item label="Agente:" name="agentId">
                    <Select
                      style={{ width: '100%' }}
                      placeholder="Selecciona una opción"
                      optionFilterProp="children"
                      filterOption={(input, option) =>
                        option.children
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                      }
                      showSearch
                    >
                      {users?.map((s: any) => (
                        <Select.Option key={s.id} value={s.id}>
                          {s.firstName}
                        </Select.Option>
                      ))}
                    </Select>
                </Form.Item>
              </Col>
              <Col xs={24} md={12}>
                <Form.Item
                  label="Tipo:"
                  name="typeId"
                >
                  <Select
                    placeholder="Selecciona una opción"
                  >
                    {customertypes?.map((e: any) => (
                      <Select.Option
                        key={e.id}
                        value={e.id}
                        disabled={
                          user.role === 'SALES' && e.description === 'Cliente'
                        }
                      >
                        {e.description}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col xs={24} md={12}>
                <Form.Item label="Calificación:" name="customerScoreId">
                  <Select
                    placeholder="Selecciona una opción"
                    allowClear
                  >
                    {customerScores?.map((e: any) => (
                      <Select.Option
                        key={e.id}
                        value={e.id}
                        disabled={
                          user.role === 'SALES' && e.description === 'Cliente'
                        }
                      >
                        {e.description}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
            </Row>

            <Row justify="end">
              <Form.Item>
                <Button
                  htmlType="submit"
                  className="btn-add"
                  disabled={isLoadingUsers || isSubmitting}
                >
                  Guardar
                </Button>
              </Form.Item>
            </Row>
          </Col>
        </Row>
      </Form>
    </Spin>
  );
};

export default CustomerAgentForm;
